<mat-card>
  <mat-card-header>
    <mat-card-title>Авторизация</mat-card-title>
  </mat-card-header>
  <form class="registration-form" [formGroup]="form" (ngSubmit)="onSubmit()">
    <mat-form-field *ngIf="showGroups" appearance="outline">
      <mat-label><mat-icon>group</mat-icon> Кто вы?</mat-label>
      <mat-select placeholder="Выберите роль" formControlName="group">
        <mat-option *ngFor="let group of groups" [value]="group">
          {{ group.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="!showGroups" hintLabel="" appearance="outline">
      <mat-label><mat-icon>person</mat-icon> Логин</mat-label>
      <input matInput #username placeholder="ваш логин" formControlName="username">
      <mat-error *ngIf="form.controls.username.invalid">Некоректный логин</mat-error>
    </mat-form-field>

    <mat-form-field *ngIf="!showGroups" hintLabel="" appearance="outline">
      <mat-label><mat-icon>security</mat-icon> Пароль</mat-label>
      <input matInput #password placeholder="Ваш пароль" [type]="hide ? 'password' : 'text'" formControlName="password">
      <button class="icon-button" mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
        [attr.aria-pressed]="hide">
        <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
    </mat-form-field>
    <hr>
    <button
      class="login-form__button"
      mat-raised-button
      matTooltipPosition="above"
      color="primary"
      [disabled]="!form.valid">Войти</button>
  </form>
  <hr>
  <div class="extra-link">
    <span><a [routerLink]="['/registration']">Регистрация</a></span>
    <span><a (click)="changePassword()">Забыли пароль</a></span>
  </div>
</mat-card>


<ng-template #resetPasswordTemplate>
  <mat-dialog-content>
    <div>
      <form class="reset-password__form" [formGroup]="formResetPassword" (ngSubmit)="changePasswordSubmit()">
        <p>Ваш email на который будет отправлена инструкция для востановления пароля</p>
        <br>
        <mat-form-field hintLabel="*Ваш email" appearance="outline">
          <mat-label>Email</mat-label>
          <input matInput #email placeholder="your email" formControlName="email">
          <mat-error *ngIf="formResetPassword.controls.email.invalid">* Обязательное поле. Пример формата example@mail.ru</mat-error>
        </mat-form-field>

        <button
          class="login-form__button"
          mat-raised-button
          matTooltipPosition="above"
          color="primary"
          [disabled]="!formResetPassword.valid">Отправить</button>
      </form>
    </div>
  </mat-dialog-content>
</ng-template>
